import { useState } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { API_URL } from "../config";
import { getCached } from "../utils/employeeCache";

// Companies rarely change within a session — cache a bit longer than the
// fast-moving employee list/counts.
const COMPANIES_TTL_MS = 5 * 60 * 1000;

// Unique companies list for the current client (used by the company filter)
export const useCompanies = ({ profile }) => {
  const [companies, setCompanies] = useState([]);

  // Function to fetch unique companies for the current client.
  // `forceRefresh` bypasses the cache when needed.
  const fetchCompanies = async (forceRefresh = false) => {
    try {
      const clientName = profile?.clientName || localStorage.getItem("clientName");

      const employeesData = await getCached(
        `manager-companies:${clientName || ""}`,
        async () => {
          let response;
          if (clientName && clientName.toLowerCase() !== "infinity") {
            // Fetch employees for specific client
            response = await apiFetch(`${API_URL}/employees/clients/${clientName}`, { method: "GET" });
          } else {
            // Fetch all employees
            response = await apiFetch(`${API_URL}/employees`, { method: "GET" });
          }
          return response.json();
        },
        { force: forceRefresh, ttl: COMPANIES_TTL_MS }
      );
      const list = employeesData.employees || employeesData;

      // Extract unique companies from workingCompany field
      const uniqueCompanies = [...new Set(
        list
          .map(emp => emp.workingCompany)
          .filter(company => company && company.trim() !== "")
      )].sort();

      setCompanies(uniqueCompanies);
      console.log(`✅ Found ${uniqueCompanies.length} unique companies`);
    } catch (err) {
      console.error("❌ Failed to fetch companies:", err);
    }
  };

  return { companies, fetchCompanies };
};
